import {createFileRoute, redirect} from '@tanstack/react-router';

export const Route = createFileRoute('/_auth/auth/')({
  beforeLoad: () => {
    throw redirect({
      to: '/auth/signin',
    });
  },
});
